import React from 'react';
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';
import './Header.css';

// Composant Header present sur toutes les pages (sauf accueil)
// Contient le logo et la barre de recherche
function Header() {
    return (
        <header className="header">
            {/* Logo cliquable pour retourner a l'accueil */}
            <Link to="/" className="header-logo">
                <span className="logo-miam">Miam</span>
                <span className="logo-miam2">Miam</span>
            </Link>

            {/* Barre de recherche */}
            <div className="header-search">
                <SearchBar />
            </div>
        </header>
    );
}

export default Header;
